import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '.';
import { UUID } from 'crypto';
import { handleGlobalSearch } from '@/utils';
import {  Treatment } from '@/utils/types';

export const treatmentsApi = createApi({
    reducerPath: 'treatmentsApi',
    tagTypes: ['treatments'],
    baseQuery: baseQuery,
    refetchOnReconnect: true,
    endpoints: (builder) => ({
        addTreatment: builder.mutation({
            query: (treatment: Partial<Treatment>) => ({
                url: `treatments`,
                method: 'POST',
                body: treatment,
            }),
            invalidatesTags: ['treatments'],
        }),

        updateTreatment: builder.mutation({
            query: ({ id, data }: { id: UUID, data: Partial<Treatment> }) => ({
                url: `treatments/${id}`,
                method: 'PATCH',
                body: data,
            }),
            invalidatesTags: ['treatments'],
        }),

        deleteTreatment: builder.mutation({
            query: (id: UUID) => ({
                url: `treatments/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['treatments'],
        }),

        getTreatments: builder.query({
            query: ({ page, filters }: { page: number; filters: any }) => ({
                url: `treatments`,
                params: { page, ...handleGlobalSearch(filters, ['name']) },
            }),
            providesTags: ['treatments'],
        }),

        getFreeTreatments: builder.query({
            query: () => ({
                url: `treatments/free`,
            }),
        }),

        getTreatmentById: builder.query<Treatment, UUID>({
            query: (id: UUID) => ({
                url: `treatments/${id}`,
            }),
            providesTags: ['treatments'],
        }),

    }),
});

export const {
    useAddTreatmentMutation,
    useUpdateTreatmentMutation,
    useDeleteTreatmentMutation,
    useGetTreatmentsQuery,
    useGetTreatmentByIdQuery,
    useGetFreeTreatmentsQuery,
    useLazyGetFreeTreatmentsQuery

} = treatmentsApi;
